import {
  getPageDecorations,
  setDocumentTitle,
  useSiteNameContext,
} from "../../context/siteNameContext";

function ThemeHeader() {
  const { siteNameList } = useSiteNameContext();
  setDocumentTitle(siteNameList, "theme");
  const decorations = getPageDecorations(siteNameList, "theme");

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "250px",
        color: "#183345",
        backgroundColor: "#feb47b",
      }}
    >
      <h2>{decorations?.header1}</h2>
    </div>
  );
}

export default ThemeHeader;
